export const STEPS = [
  { id: 1, label: "Show Deadlines" },
  { id: 2, label: "Show Contacts & Information" },
  { id: 3, label: "Booth Contract/Invoice" },
  { id: 4, label: "Hotel Reservation Information" },
  { id: 5, label: "Merchandising Program Details" },
  { id: 6, label: "New Products & Power Alley" },
  { id: 7, label: "Wild Card Contract/Invoice" },
  { id: 8, label: "Marketing Opportunities" },
  { id: 9, label: "Sponsorship Opportunities" },
  { id: 10, label: "Exhibitor Contact Update" },
];
